export const PageRankingsApiPath = {
  PAGE_RANKINGS: '/api/sites/{site_id}/page-rankings', // GET Page Rankings
  PAGE_RANKINGS_ANALYSIS: '/api/sites/{site_id}/page-rankings/analysis' // POST Page Rankings Analysis
}

export type PageRankingsApiPath = (typeof PageRankingsApiPath)[keyof typeof PageRankingsApiPath]

export interface PageRankingsVars {
  site_id: number
  period?: string
  limit?: number
  periods?: number
}

export interface PageRankingsAnalysisVars {
  site_id: number
  rankings: unknown[]
  period_type?: string
}

export interface PageRankingEntry {
  rank: number
  page_url: string
  pv: number
  uu: number
  avg_dwell_ms: number | null
  prev_rank: number | null
  rank_change: number | null
}

export interface PageRankingPeriod {
  period_label: string
  period_start: string
  period_end: string
  pages: PageRankingEntry[]
}

export interface PageRankingsResponse {
  period_type: string
  rankings: PageRankingPeriod[]
}

export interface PageRankingsAnalysisResponse {
  analysis: string
}
